import { Injectable } from '@angular/core';

import { ListResponse } from '../../models/list-response';
import { ApiService } from '../api/api.service';
import { Challenge, ChallengeFilters, CustomerChallenge, CustomerChallengeFilters } from '../../models/challenge';

@Injectable({
  providedIn: 'root'
})
export class ChallengeService {
  /**
   * A service providing access to challenges via the API.
   */
  constructor(
    private apiService: ApiService
  ) {}

  getChallenges(pageNumber?: number,
                pageSize?: number,
                filters?: ChallengeFilters): Promise<ListResponse<Challenge>> {
    return this.apiService.getCollection<Challenge, ChallengeFilters>(
      'challenges/',
      pageNumber,
      pageSize,
      filters
    );
  }

  getChallenge(id: number): Promise<Challenge> {
    return this.apiService.getItem<Challenge>(
      'challenges/',
      id
    );
  }

  addChallenge(challenge: Challenge): Promise<Challenge> {
    if (challenge.availability_start === '') {
      challenge.availability_start = null;
    }
    if (challenge.availability_end === '') {
      challenge.availability_end = null;
    }
    if (challenge.challenge_start === '') {
      challenge.challenge_start = null;
    }
    if (challenge.challenge_end === '') {
      challenge.challenge_end = null;
    }

    return this.apiService.postToAPI<Challenge>(
      'challenges/',
      challenge
    );
  }

  updateChallenge(challenge: Challenge): Promise<Challenge> {
    if (challenge.availability_start === '') {
      challenge.availability_start = null;
    }
    if (challenge.availability_end === '') {
      challenge.availability_end = null;
    }
    if (challenge.challenge_start === '') {
      challenge.challenge_start = null;
    }
    if (challenge.challenge_end === '') {
      challenge.challenge_end = null;
    }

    return this.apiService.patchToAPI<Challenge>(
      challenge.url,
      challenge
    );
  }

  getCustomerChallenges(pageNumber?: number,
                        pageSize?: number,
                        filters?: CustomerChallengeFilters): Promise<ListResponse<CustomerChallenge>> {
    return this.apiService.getCollection<CustomerChallenge, CustomerChallengeFilters>(
      'customer-challenges/',
      pageNumber,
      pageSize,
      filters
    );
  }

  getCustomerChallenge(id: number): Promise<CustomerChallenge> {
    return this.apiService.getItem<CustomerChallenge>(
      'customer-challenges/',
      id
    );
  }

  updateCustomerChallenge(customerChallenge: CustomerChallenge): Promise<CustomerChallenge> {
    if (customerChallenge.challenge_start === '') {
      customerChallenge.challenge_start = null;
    }
    if (customerChallenge.challenge_end === '') {
      customerChallenge.challenge_end = null;
    }

    return this.apiService.patchToAPI<CustomerChallenge>(
      customerChallenge.url,
      customerChallenge
    );
  }

  addCustomerToChallenge(customerId: number, challengeId: number): Promise<void> {
    return this.apiService.postToAPI<any>(
      'gym-endpoints/add-customer-to-challenge/',
      {
        customer_id: customerId,
        challenge_id: challengeId
      }
    ).then();
  }

  removeCustomerFromChallenge(customerId: number, challengeId: number): Promise<void> {
    return this.apiService.postToAPI<any>(
      'gym-endpoints/remove-customer-from-challenge/',
      {
        customer_id: customerId,
        challenge_id: challengeId
      }
    ).then();
  }
}
